import {SPV_DATA_REQUEST, SPV_CREATE_USER, SPV_UPDATE_STATUS, SPV_MATCH_PROJECT_ID, SPV_LENGTH_TASK_LIST, SPV_PAGINATION, SPV_OFFSET, SPV_GET_NOTIF_TASKLIST, SPV_NOTIF_TASKLIST_SUCCESS, SPV_NOTIF_TASKLIST_FAILED} from './actionTypes'
import {client} from '../../graphql/auth'
import { GET_TASK_SUPERVISOR } from '../../graphql/queries';

export const reqTaskListSVP = () => {
  return (dispatch) => {
    dispatch(getTaskListSVP());
    client
      .query({ query: GET_TASK_SUPERVISOR})
      .then(({ data }) => dispatch(getTaskListSVPSuccess(data)))
      .catch(({ error }) => dispatch(getTaskListSVPFailed(error)));
  };
}

export const getTaskListSVPSuccess = (data) => {
    return {
        type: SPV_NOTIF_TASKLIST_SUCCESS,
        payload: data
    }
}

export const getTaskListSVPFailed = (errMessage) => {
    return {
        type: SPV_NOTIF_TASKLIST_FAILED,
        payload: errMessage
    }
}

export const getTaskListSVP = () => {
    return {
        type: SPV_GET_NOTIF_TASKLIST,
    }
}

export const setUserData = (findAllUserAdmin) => {
    return {
        type: SPV_DATA_REQUEST,
        payload: findAllUserAdmin
    }
}

export const createNewUser = (newUserInput) => {
    return {
        type: SPV_CREATE_USER,
        payload: newUserInput
    }
}

export const getStatusSPV = (inputStatusSPV) => {
    return {
        type: SPV_UPDATE_STATUS,
        payload: inputStatusSPV
    }
}

export const matchProjectID = (projectID) => {
    return {
        type: SPV_MATCH_PROJECT_ID,
        payload: projectID
    }
}

export const getTaskListLength = (taskListData) => {
    return {
        type: SPV_LENGTH_TASK_LIST,
        payload: taskListData
    }
}

export const setCurrentPage = (currPage) => {
    return {
        type: SPV_PAGINATION,
        payload: currPage
    }
}

export const setOffPage = (offPage) => {
    return {
        type: SPV_OFFSET,
        payload: offPage
    }
}